<div id="img-div"><img src="../../../../../assets/img/openvidu_grey_bg_transp_cropped.png"/></div>
<div id="join-dialog" class="jumbotron vertical-center">
    <h1>Join a video session</h1>
    <form class="form-group" [formGroup]="joinSessionForm">
        <p>
            <label>Session</label>
            <input class="form-control" id="userName" formControlName="sessionName" required>
        </p>
        <p>
            <label>Participant</label>
            <input class="form-control" id="sessionId" formControlName="myUserName" required>
        </p>
        <p class="text-center">
            <button class="btn btn-lg btn-success join-session-btn" type="button" (click)="submit()">
                Join!
            </button>
        </p>
    </form>
</div>
